if(!customElements.get('fs-catalog-cards')){
 customElements.define('fs-catalog-cards',class extends HTMLElement{
  connectedCallback(){
   this.section=this.closest('product-info');if(!this.section)return;
   this.variants=JSON.parse(this.querySelector('[data-fs-variants]').textContent);
   this.tiers=JSON.parse(this.querySelector('[data-fs-tiers]')?.textContent||'null')||[];
   this.money=new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency:'TRY'});
   this.onChange=event=>{if(event.target.matches('input[name="id"],input[name="quantity"]'))this.refresh();};
   this.section.addEventListener('change',this.onChange,true);
   this.section.addEventListener('input',this.onChange,true);
   this.onCard=event=>{if(!event.target.matches('input[type="radio"]'))return;const input=this.quantityInput();if(!input)return;input.value=event.target.value;input.dispatchEvent(new Event('change',{bubbles:true}));this.refresh();};
   this.addEventListener('change',this.onCard);
   this.onFormData=event=>{if(!event.target.querySelector('[name="id"]'))return;const input=this.quantityInput();if(input)event.formData.set('quantity',input.value);};
   this.section.addEventListener('formdata',this.onFormData);
   const initialQuantity=Number(this.dataset.reference);
   const initialInput=this.quantityInput();
   if(initialInput&&Number.isSafeInteger(initialQuantity)&&initialQuantity>0){
    initialInput.value=String(initialQuantity);
    initialInput.dispatchEvent(new Event('change',{bubbles:true}));
   }
   this.observer=new MutationObserver(()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.refresh());});
   this.observer.observe(this.section,{childList:true,subtree:true,attributes:true,attributeFilter:['value','max','disabled']});
   this.refresh();
  }
  disconnectedCallback(){this.section?.removeEventListener('change',this.onChange,true);this.section?.removeEventListener('input',this.onChange,true);this.section?.removeEventListener('formdata',this.onFormData);this.removeEventListener('change',this.onCard);this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  quantityInput(){return this.section.querySelector('input[name="quantity"]');}
  put(element,text){if(element&&element.textContent!==text)element.textContent=text;}
  unitPrice(quantity,baseline){
   if(this.dataset.native!=='true'||!this.tiers.length||Math.round(Number(this.tiers[0].unitPrice)*100)!==Math.round(baseline))return baseline;
   let result=baseline;
   for(const point of this.tiers){if(quantity>=Number(point.quantity))result=Math.round(Number(point.unitPrice)*100);}
   return Number.isFinite(result)&&result>0&&result<=baseline?result:baseline;
  }
  refresh(){
   const id=this.section.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
   const variant=this.variants.find(v=>String(v.id)===id);if(!variant)return;
   const rate=variant.taxable?Number(this.dataset.vat):0,multiplier=1+rate/100;
   const netUnit=this.dataset.included==='true'?variant.price/multiplier:variant.price;
   const input=this.quantityInput();const quantity=Number(input?.value||1);
   for(const card of this.querySelectorAll('.fs-catalog-card')){
    const radio=card.querySelector('input'),qty=Number(radio.value);
    const unavailable=!variant.available||(variant.tracked&&qty>Math.max(0,variant.stock));
    if(radio.disabled!==unavailable)radio.disabled=unavailable;
    card.classList.toggle('is-unavailable',unavailable);radio.checked=qty===quantity;
    const tierUnit=this.unitPrice(qty,netUnit);
    this.put(card.querySelector('[data-fs-total]'),this.money.format(Math.round(tierUnit*qty)/100));
    this.put(card.querySelector('[data-fs-unit]'),this.money.format(Math.round(tierUnit)/100));
    this.put(card.querySelector('[data-fs-saving]'),tierUnit<netUnit?new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{maximumFractionDigits:1}).format((netUnit-tierUnit)*100/netUnit)+'%':'—');
   }
   const price=this.section.querySelector('.ep-premium-price');
   const selectedUnit=this.unitPrice(quantity,netUnit);
   this.put(price?.querySelector('.ep-premium-price__amount'),this.money.format(Math.round(selectedUnit*quantity)/100));
   const gross=Math.round(selectedUnit*quantity*multiplier);
   this.put(price?.querySelector('.ep-premium-price__total strong'),this.money.format(gross/100));
  }
 });
}


